import {BaseService} from "./baseService";
import {Product} from "./product";

export interface Award<DateType = string> {
    id: string;
    createdAt: DateType;
    updatedAt: DateType;
    title: string;
    label: string;
    brand: string;
    image: string;
    extract: string;
    productSection: string;
    place: string;
    product: Product;
    awardCategory: {
        id: string;
    }
}

export interface AwardCategory<DateType = string> {
    id: string;
    order: number;
    createdAt: DateType;
    updatedAt: DateType;
    title: string;
    description: string;
    awards: Award[];
}

export interface AwardYear<DateType = string> {
    id: string;
    createdAt: DateType;
    updatedAt: DateType;
    label: string;
    slug: string;
}
export class AwardService extends BaseService{
    public static async getCategoires(): Promise<AwardCategory[]> {
        const response = await this.getData<AwardCategory[]>('/awardCategories?orderBy%5Border%5D=asc');
        return response;
    }

    public static async getYears(): Promise<AwardYear[]> {
        const response = await this.getData<AwardYear[]>('/awardYears?orderBy%5Border%5D=asc');
        return response;
    }

    public static async getAwardsByCategory(categoryId: string): Promise<Award[]> {
        const response = await this.getData<Award[]>(`/awardCategories/${categoryId}/awards?orderBy%5Border%5D=asc`);
        return response;
    }

    public static async getAwardsByYear(yearId: string): Promise<Award[]> {
        const response = await this.getData<Award[]>(`/awardYears/${yearId}/awards?orderBy%5Border%5D=asc`);
        return response;
    }

    public static async getCategory(categoryId: string): Promise<AwardCategory> {
        const response = await this.getData<AwardCategory>(`/awardCategories/${categoryId}`);
        return response;
    }
}